module.exports = __webpack_public_path__ + "img/tree-09-b-leaves.da329dac.png";